import { AppAction } from "@Safemate/Store/types";
import {call, put, takeLatest} from 'redux-saga/effects';
import * as Routines from "../routines";
import * as Api from "../api";
import { feedbackFailure } from '../../../Feedback/reducer';
import { TransactionDevice } from "@Safemate/Model/TransactionDevice";

function* getDevice(action: AppAction<number>){
  try {
    const device: TransactionDevice = yield call(Api.getDevice, action.payload);
    yield put(Routines.getDevice.success(device));
  }
  catch(e){
    yield feedbackFailure(e);
    yield put(Routines.getDevice.failure());
  }
  yield put(Routines.getDevice.fulfill());
}

function* deviceSaga(){
    yield takeLatest(Routines.getDevice.TRIGGER, getDevice);
}

export default deviceSaga;
